import dayjs from "dayjs";

export const skuColumns = [
  {
    field: "skuCode",
    headerName: "SKU Code",
    flex: 1,
  },
  {
    field: "quantityAllocate",
    headerName: "Quantity Allocate",
    flex: 1,
  },
  {
    field: "quantityPicked",
    headerName: "Quantity Picked",
    flex: 1,
  },
  {
    field: "totalQuantityCancel",
    headerName: "Quantity To Cancelled",
    flex: 1,
  },
];
export const selectedSkuColumns = [
  {
    field: "skuCode",
    headerName: "SKU Code",
    flex: 1,
  },
  {
    field: "totalQuantityAllocate",
    headerName: "Total Quantity Allocate",
    flex: 1,
  },
  {
    field: "totalQuantityCancel",
    headerName: "Total Quantity To Cancelled",
    flex: 1,
  },
];
export const availableColumns = [
  {
    field: "remainingStockQuantity",
    headerName: "Quantity",
    width: 150,
    flex: 1,
  },
  {
    field: "zoneID",
    headerName: "Zone ID",
    width: 150,
    flex: 1,
  },
  {
    field: "locationID",
    headerName: "Location ID",
    width: 150,
    flex: 1,
  },
  {
    field: "palletNbr",
    headerName: "Pallet Number",
    width: 150,
    flex: 1,
  },
  {
    field: "cartonID",
    headerName: "Carton ID",
    width: 150,
    flex: 1,
  },
  {
    field: "skuCode",
    headerName: "SKU Code",
    width: 150,
    flex: 1,
  },
  {
    field: "mln",
    headerName: "MLN",
    width: 100,
  },
  {
    field: "expiryDate",
    headerName: "Expiry Date",
    width: 120,
    valueFormatter: (value) => {
      if (!value) return "";
      return dayjs(value).format("DD-MM-YYYY");
    },
  },
];
export const pickslipColumns = [
  {
    field: "zoneID",
    headerName: "Zone ID",
    width: 150,
    colSpan: (value, row, column, apiRef) => {
      if (row.id === "Total") {
        return 7;
      }
      return undefined;
    },
    valueGetter: (value, row, column, apiRef) => {
      if (row.id === "Total") {
        return row.label;
      }
      return value;
    },
  },
  {
    field: "locationID",
    headerName: "Location ID",
    width: 120,
  },
  {
    field: "palletNbr",
    headerName: "Pallet Number",
    width: 120,
  },
  {
    field: "cartonID",
    headerName: "Carton ID",
    width: 100,
  },
  {
    field: "skuCode",
    headerName: "SKU Code",
    width: 150,
  },
  {
    field: "mln",
    headerName: "MLN",
    width: 100,
  },
  {
    field: "expiryDate",
    headerName: "Expiry Date",
    width: 120,
    valueFormatter: (value) => {
      if (!value) return "";
      return dayjs(value).format("DD-MM-YYYY");
    },
  },
  // {
  //   field: "quantityAllocate",
  //   headerName: "Qty Allocated",
  //   align: "right",
  //   width: 140,
  //   sortable:false
  // },
  {
    field: "quantityPicked",
    headerName: "Qty Picked",
    width: 120,
    editable: true,
    type: "number",
    align: "right",
    headerClassName: "custom-editable-header",
    sortable: false,
    //flex: 1,
  },
];
export const allocateColumns = [
  {
    field: "orderNumber",
    headerName: "Order Number",
    width: 180,
    flex: 1,
    colSpan: (value, row, column, apiRef) => {
      if (row.id === "Total") {
        return 2;
      }
      return undefined;
    },
    valueGetter: (value, row, column, apiRef) => {
      if (row.id === "Total") {
        return row.label;
      }
      return value;
    },
  },
  {
    field: "skuCode",
    headerName: "SKU Code",
    width: 150,
    flex: 1,
  },
  {
    field: "quantityAllocate",
    headerName: "Qty Allocated",
    align: "right",
    width: 140,
    flex: 1,
    sortable: false,
  },
  {
    field: "quantityPicked",
    headerName: "Qty Picked",
    width: 120,
    flex: 1,
    editable: true,
    type: "number",
    align: "right",
    headerClassName: "custom-editable-header",
    sortable: false,
  },
  {
    field: "quantityCancel",
    headerName: "Qty To Cancelled",
    width: 160,
    align: "right",
    sortable: false,
  },
];
export const previewColumns = [
  // {
  //   field: "orderNumber",
  //   headerName: "Order Number",
  //   width: 180,
  //   flex: 1,
  //   colSpan: (value, row, column, apiRef) => {
  //     if (row.id === "Total") {
  //       return 7;
  //     }
  //     return undefined;
  //   },
  //   valueGetter: (value, row, column, apiRef) => {
  //     if (row.id === "Total") {
  //       return row.label;
  //     }
  //     return value;
  //   },
  // },
  {
    field: "zoneID",
    headerName: "Zone ID",
    width: 180,
    flex: 1,
  },
  {
    field: "locationID",
    headerName: "Location ID",
    width: 150,
    flex: 1,
  },
  {
    field: "palletNbr",
    headerName: "Pallet Number",
    width: 150,
    flex: 1,
  },
  {
    field: "cartonID",
    headerName: "Carton ID",
    width: 150,
    flex: 1,
  },
  {
    field: "skuCode",
    headerName: "SKU Code",
    width: 150,
    flex: 1,
  },
  {
    field: "mln",
    headerName: "MLN",
    width: 100,
  },
  {
    field: "expiryDate",
    headerName: "Expiry Date",
    width: 120,
    valueFormatter: (value) => {
      if (!value) return "";
      return dayjs(value).format("DD-MM-YYYY");
    },
  },
  // {
  //   field: "quantityAllocate",
  //   headerName: "Qty Allocated",
  //   align: "right",
  //   width: 140,
  //   flex: 1,
  // },
  {
    field: "quantityPicked",
    headerName: "Qty Picked",
    width: 120,
    flex: 1,
    editable: true,
    type: "number",
    align: "right",
  },
];
